import {
    SUBMIT_FINAL,
    SUBMIT_BUTTON_UPDATE
  } from '../config/constants';
  
  const INITIAL_STATE = {
    isValidated: true,
    isFinal: false,
  };
  
  export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
      case SUBMIT_FINAL: {
        
        return { ...state, isFinal: payload };
      }
      case SUBMIT_BUTTON_UPDATE: {
        return { ...state, isValidated: !payload };
      }
      default:
        return state;
    }
  };
  